
export const CURRENT_PAGE = (state, value) => {
  state.currentPage = value
}